import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Boot-time configuration check
if (typeof window !== "undefined" && !process.env.REACT_APP_BACKEND_URL) {
  console.warn(
    "[bootstrap] REACT_APP_BACKEND_URL is not set in build environment. Defaulting API requests to current origin /api."
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
